import React from 'react';
import s from '../../styles/organisms/closing-notice.module.scss';

/** トップページ用：ボックス型クロージングお知らせ */
export const ClosingNoticeBox: React.FC = () => {
  return (
    <div className={s.closingBox}>
      <h2 className={s.closingBoxTitle}>「P-man」プロジェクト終了のお知らせ</h2>
      <p className={s.closingBoxText}>
        「ペットのコンシェルジュがいる賃貸マンション『P-man』プロジェクト」
        <br />
        につきまして、誠に残念でございますが、2026年3月末をもってプロジェクトを終了いたしました。
      </p>
      <p className={s.closingBoxText}>
        いただいた数多くのアイデア、ご希望、住まいに関するお声は、
        <br />
        すべて事業化に向けた検証の中で大切に活用させていただきました。
      </p>
      <p className={s.closingBoxText}>心より感謝申し上げます。誠にありがとうございました。</p>
    </div>
  );
};

/** 下層ページ用：バー型クロージングお知らせ */
export const ClosingNoticeBar: React.FC = () => {
  return (
    <div className={s.closingBar}>
      「ペットのコンシェルジュがいる賃貸マンション『P-man』プロジェクト」は、2026年3月末をもってプロジェクトを終了いたしました。
    </div>
  );
};
